﻿$.fn.dxCtrlGetNbPersonne = function custom_dxCtrlGetNbPersonne(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass(" dx-ctrlgetnbpersonne dx-ctrl");
        this.createInstance(new cdxCtrlGetNbPersonne(this, option));
    }
    return this;
}

window.cdxCtrlGetNbPersonne = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $DivDisplay = null
    var $DivModif = null
    function mConstruit() {
        container.empty();
        container.css("text-align","center")
        var maxNb = option.bddCtrl.getObjet("hebergement").objetMetier.mGetMaxNbPersonneAllHebergement()
        if (option.dataHebergement) {
            maxNb = option.bddCtrl.getObjet(option.dataHebergement).objetMetier.mGetMaxNbPersonneHebergement()
        }
        if (maxNb < option.value.nb_adulte + option.value.nb_enfant) maxNb = option.value.nb_adulte + option.value.nb_enfant

        var dsAdulte = [0]
        for (var i = 1; i <= maxNb; i++) dsAdulte.push(i)
        $("<i class='fas fa-person' style='font-size:250%;'></i>").appendTo(container)
        $("<div style='display:inline-block;' title='Nombre adulte'/>").appendTo(container).dxSelectBox({
            labelMode: 'floating',
            label: "Adulte",
            width: option.width ?? 75,
            showDropDownButton: false,
            dataSource: dsAdulte,
            value: option.value.nb_adulte,
            disabled: option.disabled,
            dropDownOptions: {
                container: container
            },
            onValueChanged: function (e) {
                option.value.nb_adulte = e.value
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged({ value: option.value })
                mConstruit()
            }
        })

        $("<span> &bull; </span>").appendTo(container)
        $("<i class='fas fa-child-reaching' style='font-size:250%;'></i>").appendTo(container)
        var dsEnfant = [0]
        for (var i = 1; i <= maxNb; i++) dsEnfant.push(i)
        $("<div style='display:inline-block;' title='Nombre enfant'/>").appendTo(container).dxSelectBox({
            labelMode: 'floating',
            label: "Enfant",
            width: option.width ?? 75,
            showDropDownButton: false,
            dataSource: dsEnfant,
            value: option.value.nb_enfant,
            disabled: option.disabled,
            dropDownOptions: {
                container: container
            },
            onValueChanged: function (e) {
                option.value.nb_enfant = e.value
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged({ value: option.value })
                mConstruit()
            }
        })
    }

    this.element = function () { return container; }

    mConstruit();

}